export default __webpack_public_path__ + "static/media/misc-closetA-2048w.9ec2ce38.avif";